/*
 * Copyright (c) 2023 Bolmate B.V.
 */
import './style/testMail.scss';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler} from 'react';
import {ChangeFunction, CloseButton, ErrorType, Loader, WithBackground} from '@dvrd/dvr-controls';
import {BolmateButton, BolmateInput} from "../../controls";
import EmailDisabledMessage from '../../misc/emailDisabledMessage';

interface Props {
    onChange: ChangeFunction<string>;
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onClose: MouseEventHandler;
    onResetError: FocusEventHandler;
    error: ErrorType;
    active: boolean;
    email: string;
    loading: boolean;
}

export default function TestMail(props: Props) {
    const {onClose, loading, error, onChange, active, email, onSubmit, onResetError} = props;

    return (
        <WithBackground active={active} onClose={onClose}>
            <div className='test-mail-popup default-popup'>
                <div className='header-container'>
                    <label className='header-title'>Test mail verzenden</label>
                    <CloseButton onClick={onClose}/>
                </div>
                <div className='loading-content'>
                    <Loader active={loading}/>
                    <div className='body-container'>
                        <label className='description'>De test e-mail wordt verzonden naar:</label>
                        <BolmateInput onChange={onChange} value={email} inputProps={{type: 'email'}}
                                      onEnter={onSubmit} error={error} onFocus={onResetError}
                                      ornaments={{
                                          element: <EmailDisabledMessage>Vanwege veiligheid is het niet mogelijk dit
                                              e-mailadres aan te passen.</EmailDisabledMessage>
                                      }} autoFocus
                                      disabled/>
                    </div>
                    <div className='footer-container'>
                        <BolmateButton onClick={onClose} label='Annuleren' secondary/>
                        <BolmateButton onClick={onSubmit} label='Verzenden' disabled={!email.length}/>
                    </div>
                </div>
            </div>
        </WithBackground>
    )
}